import * as Types from 'src/actions/active-profile/set/Types';
import { Action } from 'redux';
import { ActionCreator } from 'react-redux';
import Person from 'src/entities/Person';

export interface SetActiveProfile extends Action {
  type: Types.SET_ACTIVE_PROFILE;
  payload: Person;
}

export type SetActiveProfileAction = SetActiveProfile;

export const setActiveProfile: ActionCreator<SetActiveProfile> = (person: Person) => (
  {
    type: Types.SET_ACTIVE_PROFILE,
    payload: person
  }
);


// WEBPACK FOOTER //
// ./src/actions/active-profile/set/SetActiveProfile.actions.tsx